module.exports = __webpack_public_path__ + "static/img/trbg_1.76b2fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/trbg_1.jpg
// module id = Krjo
// module chunks = 9